// Strings found by scanning pages in Arabic (defaults, pseudo-categories,
// lookup tables).
export default {
  "Everything": "الكل",
  "All": "الكل",
  "Explore the menu, find your favorites, and let us take care of the rest.": "استكشف القائمة، واختر أطباقك المفضلة، واترك الباقي علينا.",
  "Explore our collection. Choose the details that suit you, then collect in store or request delivery.": "استكشف تشكيلتنا. اختر ما يناسبك، ثم استلم من المتجر أو اطلب التوصيل.",
  "Track every order": "تتبّع كل طلب",
  "See the status of your orders live.": "شاهد حالة طلباتك مباشرة.",
  "Earn rewards": "اكسب المكافآت",
  "Collect points each time you order.": "اجمع النقاط مع كل طلب.",
  "Faster checkout": "دفع أسرع",
  "Your details are ready next time.": "بياناتك جاهزة في المرة القادمة.",
  "Mon": "إث",
  "Tue": "ثل",
  "Wed": "أر",
  "Thu": "خم",
  "Fri": "جم",
  "Sat": "سب",
  "Sun": "أح",
  "available": "متاح",
  "fully booked": "محجوز بالكامل",
  "closed": "مغلق",
  "loading": "جارٍ التحميل",
  "Category updated successfully": "تم تحديث التصنيف بنجاح",
  "Category created successfully": "تم إنشاء التصنيف بنجاح",
  "Saved successfully": "تم الحفظ بنجاح",
  "Created successfully": "تم الإنشاء بنجاح",
  "Table updated successfully": "تم تحديث الطاولة بنجاح",
  "Table created successfully": "تم إنشاء الطاولة بنجاح",
  "Item {v0}": "العنصر {v0}",
  "Booking {status}": "الحجز: {status}",
  "activate": "تفعيل",
  "deactivate": "إلغاء تفعيل",
  "suspend": "تعليق",
  "reactivate": "إعادة تفعيل",
  "confirm": "مؤكد",
  "cancel": "ملغي",
  "Failed to {action} restaurant": "تعذر {action} المطعم",
  "\"{item}\" is out of stock.": "نفد مخزون \"{item}\".",
  "Only {left} left of \"{item}\". Lower the quantity and try again.": "بقي {left} فقط من \"{item}\". قلّل الكمية وحاول مرة أخرى."
}
